import React from 'react';
import { FormattedMessage } from 'react-intl';

const ValuePropsStrings = {
  linkCalendar: (
    <FormattedMessage
      id="calendar.sync_flow.dialog.value_props.link_external"
      defaultMessage="Link your external calendar to show your availability in real time and increase your bookings."
    />
  ),
  connectAccount: (
    <FormattedMessage
      id="calendar.sync_flow.dialog.value_props.connect_external"
      defaultMessage="Connect your Google, iCal, iCloud, Office 365, Exchange, or Outlook account in a few easy steps."
    />
  ),
  privacyNotice: (
    <FormattedMessage
      id="calendar.sync_flow.dialog.value_props.security"
      defaultMessage="We will never share your personal information or event details."
    />
  )
};

export default ValuePropsStrings;
